import { render, staticRenderFns } from "./AddOtherDocuments.vue?vue&type=template&id=ba115c84&scoped=true"
import script from "./AddOtherDocuments.vue?vue&type=script&lang=js"
export * from "./AddOtherDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba115c84",
  null
  
)

export default component.exports